 <template>
  <div style="z-index: 40;">
    <div class="register-box">
      <div class="register-box-form">
        <form v-on:keyup.enter="register" class="uk-form-stacked uk-margin-remove">
          <legend class="uk-legend uk-text-center">Create an account</legend>
          <!-- EMAIL -->
          <div class="uk-margin">
            <label class="uk-form-label uk-margin-top" for="form-horizontal-text-email2">Email</label>
            <div class="uk-form-controls form-label">
              <input autocomplete="email" v-model="email" class="uk-input uk-form-expand" id="form-horizontal-text-email2" type="text">
            </div>  
            <!-- FULL NAME -->
            <label class="uk-form-label uk-margin-top" for="form-horizontal-text-full-name">Full name</label>
            <div class="uk-form-controls form-label">
              <input autocomplete="name" v-model="name" class="uk-input uk-form-expand" id="form-horizontal-text-full-name" type="text">
            </div>                   
            <!-- PASSWORD -->   
            <label class="uk-form-label uk-margin-top" for="form-horizontal-text-password2">Password</label>
            <div class="uk-form-controls">
              <input v-model="password" class="uk-input uk-form-expand" id="form-horizontal-text-password2" type="password">
            </div>   
            <!-- CONFRIM PASSWORD  
            <label class="uk-form-label uk-margin-top" for="form-horizontal-text">Confirm password</label>
            <div class="uk-form-controls">
              <input v-model="passwordConfirm" class="uk-input uk-form-expand" id="form-horizontal-text" type="password">
            </div>    -->                                                  
          </div>           
          <!-- REGISTER BUTTON -->
          <a @click="register" class="uk-button uk-button-danger uk-margin uk-width-1-1" style="font-size: 16px; border-radius: 2px;"><b>Create Watermarks.io Account</b></a>
          <!-- Back to Login -->
          <div>
            <!-- Register shows as modal at times. Login is an actual route, so choosing to go to it, make sure you close
            if a modal by including uk-modal-close-default -->
            <span>Have an account?&nbsp;</span> <router-link to="/login" class="uk-link uk-modal-close">Log in.</router-link>
          </div>        
        </form>
        <div class="hr-sect"><i>or</i></div>
        <!-- Google Sign In Button -->
        <button @click="googleSignInWithPopup" type="button" class="google-button uk-margin-small-top">
          <span class="google-button__icon">
            <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg"><path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" id="Shape" fill="#EA4335"/><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" id="Shape" fill="#FBBC05"/><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" id="Shape" fill="#4285F4"/><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853"/></svg>
          </span>
          <span class="google-button__text">Sign in with Google</span>
        </button>        
      </div>
    </div> 
  </div>
</template>

<script>
  // SAVE WM Function
  async function firebaseSaveWM(userId, marks) {
    // Save mark to firebase                
    let wmRef = firebase.firestore().collection('watermarks').doc(userId).collection('marks'); 
    let storage = firebase.storage();                
    let numMarks = Array.apply(null, {length: marks.length}).map(Number.call, Number) //makes simple array [0,1,2,...]
    
    for (const pos of numMarks) {
      // 1) Add watermark json to Firestore and get document reference
      const addWmToStore = wmRef.add(marks[pos]);
      const docRef = await addWmToStore;
      docRef.update({documentId: docRef.id})
      marks[pos].documentId = docRef.id; 

      // 2) Now that we have docRef, put png and svg in Firebase Storage
      const putPNG = storage.ref('user/' + userId + '/watermarks/' + docRef.id + '.png').putString(marks[pos].png, 'data_url')
      const putSVG = storage.ref('user/' + userId + '/watermarks/' + docRef.id + '.svg').putString(marks[pos].svg)       

      const uploadTasks = [putPNG, putSVG].map(task => {
          return task
      })     
      const uploadTasksComplete = await Promise.all(uploadTasks) 
      
      // png
      const url = await uploadTasksComplete[0].metadata.ref.getDownloadURL()
      wmRef.doc(docRef.id).update({png: url})

      // svg
      const url2 = await uploadTasksComplete[1].metadata.ref.getDownloadURL()
      wmRef.doc(docRef.id).update({svg: url2})
    }               
  }


import Vue from 'vue'
import firebase from 'firebase/app'


  export default {
    name: 'Homepage',
    data () {
      return {
        email: '',
        name: '',
        password: '',
        passwordConfirm: ''
      }
    },
    methods: {
      register: function() {
        var me;
        me = this;

        // pinterest only asks for password once... doing same here
        if (this.passwordConfirm === null || this.passwordConfirm === '') {
          this.passwordConfirm = this.password
        }

        // check if passwords match
        if (this.password != this.passwordConfirm) {
          UIkit.notification({message: 'Passwords must be the same', status: 'danger', pos: 'bottom-center'})
          return
        }

        // authenticate with firebase
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
          .then(function(data){
            
            const user = data.user
            const userId = user.uid;

            // Notify successful
            UIkit.notification({message: '<i class="material-icons uk-inline wm-green2">how_to_reg</i> Account created.', pos: 'bottom-center'})            
            
            // If user just created an account, save their watermark
            if (me.globalMarks.savedMarks.length > 0) {              
              /* save wm's to variable because when new user is created function refreshWatermarks() is called 
              which clears all watermarks and refreshes them... so in this case:
              1.) user creates new account
              2.) after account created, onAuthStateChanged() fires which clears out local wm's
              2.1) there's nothing in firestore yet so wm local will get updated to blank
              3) we upload all wm's saved in variable 
              4) uploading to this users account will trigger marksRef.onSnapshot which will download firestore wm locally */

              // async function defined above vue script section because it will be called by email login and google auth

              var tempSavedMarks = me.globalMarks.savedMarks
              firebaseSaveWM(userId, tempSavedMarks) 
            }
            
            // Start export if user created account after prompt from clicking "Export"
            if (me.$parent.registerSource==='export') {
              me.$root.$emit('eventBusStartExport');
            }

            // Send Email verification
            // let user = firebase.auth().currentUser;
            user.sendEmailVerification();    

            // Create Avatar
            var img = new Image();
            // need to wait for dataURL to be ready before setting or else it'll be blank
            img.onload = function () {
              // after user is created, add display name and profile pic
              if(user){
                // update firebase user to include displayName and Avatar
                user.updateProfile({
                  displayName: me.name,
                  photoURL: img.src
                }).then(
                  (s)=> {
                    // onAuthStateChange in main.js does not capture profile updates, so upon account creation it will not pull back the newly published
                    // displayName and photoURL... so I'm going to set these now
                    Vue.set(me.globalSessionInfo, 'currentUser', {});
                    Vue.set(me.globalSessionInfo.currentUser, 'isLoggedIn', true);                  
                    Vue.set(me.globalSessionInfo.currentUser, 'displayName', me.name);
                    Vue.set(me.globalSessionInfo.currentUser, 'photoURL', img.src);
                    // go home
                    me.$router.replace('/apply')
                  }
                )
              }
            }
            img.src = me.initialsImg(me.name, 40)              
          },
          function(err) {
            UIkit.notification({message: err.message, status: 'danger', pos: 'bottom-center'})
          }
        );
      },
      googleSignInWithPopup: function() {
        var me;
        me = this;

        // Google Auth Provider
        var provider = new firebase.auth.GoogleAuthProvider();

        firebase.auth().signInWithPopup(provider).then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          
          // The signed-in user info.
          const user = result.user
          const userId = user.uid
          
          // Notify successful
          UIkit.notification({message: '<i class="material-icons uk-inline wm-green2">how_to_reg</i> Successfully Signed In.', pos: 'bottom-center'})            
          
          // If user just created an account, save their watermark
          if (me.globalMarks.savedMarks.length > 0) {              
            var tempSavedMarks = me.globalMarks.savedMarks
            firebaseSaveWM(userId, tempSavedMarks) 
          }
          
          // Remove sign up popup by forcibly switching to apply page
          me.$router.replace('/apply')

          // Start export if user created account after prompt from clicking "Export"
          if (me.$parent.registerSource==='export') {
            me.$root.$emit('eventBusStartExport');
          }
        }).catch(function(error) {
          console.log(error)
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
        });
      },
      initialsImg: function(name, size) {
        name = name || '';
        size = size || 40;
        var colours = [
          "#22CAA3"
        ],
        nameSplit = String(name)
        .toUpperCase()
        .split(' '),
        charCodeSum = name
          .split('')
          .map((c) => {
            return c.charCodeAt(0)
          })
        .reduce((a, b) => a + b, 0)
        let initials, charIndex, colourIndex, canvas, context, dataURI;
        if (nameSplit.length == 1) {
          initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
        } else {
          initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        }
        if (window.devicePixelRatio) {
          size = (size * window.devicePixelRatio);
        }
        charIndex = (initials == '?' ? 72 : charCodeSum) - 64;
        colourIndex = charIndex % colours.length;
        canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        context = canvas.getContext("2d");
        context.fillStyle = colours[colourIndex];
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = Math.round(canvas.width / 2) + "px Poppins";
        context.textAlign = "center";
        context.fillStyle = "#FFF";
        context.fillText(initials, size / 2, size / 1.5);
        dataURI = canvas.toDataURL('image/png', 0.90);
        canvas = null;
        return dataURI;
      }      
    }
  }
</script>

<style scoped>
  .register-box {
    border: 1px solid gray;
    border-radius: 5px;
    width: 400px;
    background: white;
  }

  .register-box-form {
    padding: 40px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);  
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
    border-radius: 5px !important;
    z-index: 1550 !important;
  }

  .uk-form-label  {
    font-size: 16px;
  }

  /* hr sect separator */
  .hr-sect {
    display: flex;
    flex-basis: 100%;
    align-items: center;
    color: rgba(0, 0, 0, 0.35);
    margin: 8px 0px;
  }
  .hr-sect::before,
  .hr-sect::after {
    content: "";
    flex-grow: 1;
    background: rgba(0, 0, 0, 0.35);
    height: 1px;
    font-size: 0px;
    line-height: 0px;
    margin: 0px 8px;
  }

  /* Google Sign In Button */
  .google-button {
    cursor: pointer;
    height: 40px;
    width: 100%;
    border-width: 0;
    background: white;
    color: #737373;
    border-radius: 5px;
    white-space: nowrap;
    box-shadow: 1px 1px 0px 1px rgba(0, 0, 0, 0.05);
    transition-property: background-color, box-shadow;
    transition-duration: 150ms;
    transition-timing-function: ease-in-out;
    padding: 0;
  }
  .google-button:focus, .google-button:hover {
    box-shadow: 1px 4px 5px 1px rgba(0, 0, 0, 0.1);
  }
  .google-button:active {
    background-color: #e5e5e5;
    box-shadow: none;
    transition-duration: 10ms;
  }

  .google-button__icon {
    display: inline-block;
    vertical-align: middle;
    margin: 8px 0 8px 8px;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
  }

  .google-button__icon--plus {
    width: 27px;
  }

  .google-button__text {
    display: inline-block;
    vertical-align: middle;
    padding: 0 24px;
    font-size: 14px;
    font-weight: bold;
    font-family: 'Roboto',arial,sans-serif;
  }

</style>